var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 633 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #db0d19;\n      }\n\n      .cls-2 {\n        fill: #303334;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #717070;\n        stroke-width: .5px;\n      }\n\n      .cls-4 {\n        fill: #909091;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: #f2f2f1;\n      }\n\n      .cls-7 {\n        isolation: isolate;\n      }\n\n      .cls-8 {\n        fill: #d2d2d2;\n      }\n\n      .cls-9 {\n        fill: #272727;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3417",
    className: "cls-8",
    d: "M77.6,65.8c81.5-81.5,213.5-81.5,295,0,81.5,81.5,81.5,213.5,0,295-81.5,81.5-213.5,81.5-295,0,0,0,0,0,0,0-81.5-81.5-81.5-213.5,0-295,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_44",
    className: "cls-8",
    cx: 225.1,
    cy: 213.2,
    r: 193.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32356",
    className: "cls-4",
    x: 54.7,
    y: 123.4,
    width: 340.7,
    height: 180.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32357",
    className: "cls-6",
    x: 69.3,
    y: 137.3,
    width: 312.4,
    height: 152.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32358",
    className: "cls-2",
    x: 144.8,
    y: 304.1,
    width: 157,
    height: 11.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32359",
    className: "cls-4",
    x: 95,
    y: 315.8,
    width: 256.6,
    height: 7.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4731",
    className: "cls-1",
    d: "M583.6,206.2c-51.3-51.3-134.5-51.2-185.7,0-51.3,51.3-51.2,134.5,0,185.7,51.3,51.3,134.5,51.2,185.7,0,24.6-24.6,38.4-58,38.4-92.8,0-34.9-13.8-68.3-38.5-92.9ZM547.4,355.3c-5.8,5.7-15.2,5.7-21,0l-35.7-35.7-35.9,35.9c-5.7,5.9-15.1,6-21,.3-5.9-5.7-6-15.1-.3-21,0,0,.2-.2.3-.3l35.8-35.8-35.7-35.7c-5.8-5.8-5.8-15.2,0-21,5.8-5.7,15.1-5.8,20.9,0h0s35.7,35.7,35.7,35.7l35.5-35.5c5.8-5.8,15.2-5.8,21,0,5.8,5.8,5.8,15.2,0,21,0,0,0,0,0,0h0l-35.5,35.5,35.7,35.6c5.8,5.8,5.8,15.2,0,21h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M132.8,187.7h185c11.8,0,21.5,9.6,21.5,21.5h0c0,11.8-9.6,21.5-21.5,21.5h-185c-11.8,0-21.5-9.6-21.5-21.5h0c0-11.8,9.6-21.5,21.5-21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.8,188.3h185c11.5,0,20.8,9.3,20.8,20.8h0c0,11.5-9.3,20.8-20.8,20.8h-185c-11.5,0-20.8-9.3-20.8-20.8h0c0-11.5,9.3-20.8,20.8-20.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M175,209.5l-5.2-1.7.5-1.6,5.2,1.9v-5.8c0,0,1.6,0,1.6,0v5.9c-.1,0,5-2,5-2l.5,1.6-5.2,1.8,3.5,4.6-1.3,1-3.4-4.8-3.2,4.8-1.3-1,3.4-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M188.7,209.5l-5.2-1.7.5-1.6,5.2,1.9v-5.8c0,0,1.6,0,1.6,0v5.9c-.1,0,5-2,5-2l.5,1.6-5.2,1.8,3.5,4.6-1.3,1-3.4-4.8-3.2,4.8-1.3-1,3.4-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M202.3,209.5l-5.2-1.7.5-1.6,5.2,1.9v-5.8c0,0,1.6,0,1.6,0v5.9c-.1,0,5-2,5-2l.5,1.6-5.2,1.8,3.5,4.6-1.3,1-3.4-4.8-3.2,4.8-1.3-1,3.4-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M216,209.5l-5.2-1.7.5-1.6,5.2,1.9v-5.8c0,0,1.6,0,1.6,0v5.9c-.1,0,5-2,5-2l.5,1.6-5.2,1.8,3.5,4.6-1.3,1-3.4-4.8-3.2,4.8-1.3-1,3.4-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M229.6,209.5l-5.2-1.7.5-1.6,5.2,1.9v-5.8c0,0,1.6,0,1.6,0v5.9c-.1,0,5-2,5-2l.5,1.6-5.2,1.8,3.5,4.6-1.3,1-3.4-4.8-3.2,4.8-1.3-1,3.4-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M243.3,209.5l-5.2-1.7.5-1.6,5.2,1.9v-5.8c0,0,1.6,0,1.6,0v5.9c-.1,0,5-2,5-2l.5,1.6-5.2,1.8,3.5,4.6-1.3,1-3.4-4.8-3.2,4.8-1.3-1,3.4-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M256.9,209.5l-5.2-1.7.5-1.6,5.2,1.9v-5.8c0,0,1.6,0,1.6,0v5.9c-.1,0,5-2,5-2l.5,1.6-5.2,1.8,3.5,4.6-1.3,1-3.4-4.8-3.2,4.8-1.3-1,3.4-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M270.6,209.5l-5.2-1.7.5-1.6,5.2,1.9v-5.8c0,0,1.6,0,1.6,0v5.9c-.1,0,5-2,5-2l.5,1.6-5.2,1.8,3.5,4.6-1.3,1-3.4-4.8-3.2,4.8-1.3-1,3.4-4.7Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.abaa34c1eb43cf5823808b6fc216ad46.svg";
export { ForwardRef as ReactComponent };